import { ApiClient } from "../../api-client";
import { AccessCodeLoggerClient } from "./access-code";
import { ClipboardLoggerClient } from "./clipboard";
import { HttpLoggerClient } from "./http";
import { ScreenshotLoggerClient } from "./screenshot";
import { SessionLoggerClient } from "./session";
import { TabLoggerClient } from "./tab";
import { KeyboardLoggerClient } from "./keyboard";
import EventEmitter from "events";
import { LiveLoggerClient } from "./live";
import { SystemLoggerClient } from "./system";
import { FaceDetectionLoggerClient } from "./face-detection";
import { InterruptLoggerClient } from "./interrupt";
import { UserActionLoggerClient } from "./user-action";
import { WorkerLoggerClient } from "./worker";
import { MediaLoggerClient } from "./media";
import { MachineLearningLoggerClient } from "./machine-learning";
import { IdLoggerClient } from "./id";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LoggerClientListener = (data: { type: string; name: string; details?: any }) => void;
const emitter = new EventEmitter();

export default class LoggerClient extends ApiClient {
	readonly TabLoggerClient: TabLoggerClient;
	readonly HttpLoggerClient: HttpLoggerClient;
	readonly AccessCodeLoggerClient: AccessCodeLoggerClient;
	readonly ClipboardLoggerClient: ClipboardLoggerClient;
	readonly ScreenshotLoggerClient: ScreenshotLoggerClient;
	readonly SessionLoggerClient: SessionLoggerClient;
	readonly InterruptLoggerClient: InterruptLoggerClient;
	readonly KeyboardLoggerClient: KeyboardLoggerClient;
	readonly LiveLoggerClient: LiveLoggerClient;
	readonly SystemLoggerClient: SystemLoggerClient;
	readonly FaceDetectionLoggerClient: FaceDetectionLoggerClient;
	readonly UserActionLoggerClient: UserActionLoggerClient;
	readonly WorkerLoggerClient: WorkerLoggerClient;
	readonly MediaLoggerClient: MediaLoggerClient;
	readonly MachineLearningLoggerClient: MachineLearningLoggerClient;
	readonly IdLoggerClient: IdLoggerClient;
	on: (eventName: "log", listener: LoggerClientListener) => void;
	off: (eventName: "log", listener: LoggerClientListener) => void;
	once: (eventName: "log", listener: LoggerClientListener) => void;
	// readonly ToolbarLoggerClient: ToolbarLoggerClient;
	constructor(config: ApiClient["config"]) {
		super(config, {});
		this.TabLoggerClient = new TabLoggerClient(config, emitter);
		this.HttpLoggerClient = new HttpLoggerClient(config, emitter);
		this.AccessCodeLoggerClient = new AccessCodeLoggerClient(config, emitter);
		this.ClipboardLoggerClient = new ClipboardLoggerClient(config, emitter);
		this.ScreenshotLoggerClient = new ScreenshotLoggerClient(config, emitter);
		this.SessionLoggerClient = new SessionLoggerClient(config, emitter);
		this.InterruptLoggerClient = new InterruptLoggerClient(config, emitter);
		this.KeyboardLoggerClient = new KeyboardLoggerClient(config, emitter);
		this.LiveLoggerClient = new LiveLoggerClient(config, emitter);
		this.SystemLoggerClient = new SystemLoggerClient(config);
		this.FaceDetectionLoggerClient = new FaceDetectionLoggerClient(config);
		this.UserActionLoggerClient = new UserActionLoggerClient(config, emitter);
		this.WorkerLoggerClient = new WorkerLoggerClient(config);
		this.MediaLoggerClient = new MediaLoggerClient(config);
		this.MachineLearningLoggerClient = new MachineLearningLoggerClient(config);
		this.IdLoggerClient = new IdLoggerClient(config, emitter);
		// this.ToolbarLoggerClient = new ToolbarLoggerClient(config);
		this.on = emitter.on.bind(emitter);
		this.once = emitter.once.bind(emitter);
		this.off = emitter.off.bind(emitter);
	}
}
